import React, { useState, useEffect } from "react";
import { If } from "react-condition";
import { useParams } from "react-router-dom";
import axios from "../../../services/axios";

function TextField({
  onBlurHandler,
  isInputFieldTouched,
  data,
  defaultValue,
  isChild,
  approve,
  hasChiledReadOnly,
  ocrDisabled,
  errorInputs,
}) {
  const { id, ids } = useParams();
  const formId = id;
  const candidateId = ids;
  const [defValue, setDefValue] = useState("");

  const [element, setElement] = useState({
    type: "textarea",
    properties: {
      label: "Long Input Element",
      placeholder: "Enter Long Input Element here...",
      required: true,
    },
  });

  const [readOnly, setReadOnly] = useState(false);

  //set child to required by default -Lovejot(08-DEC-2022)
  useEffect(() => {
    setElement((prev) => ({ ...prev, ...data }));
    // if (isChild) {
    //   let obj = { ...data };
    //   obj.properties.required = true;
    //   setElement((prev) => ({ ...prev, ...obj }));
    // }
    //check prefilled field -Lovejot(07-DEC-2022)
    if (
      data?.disableField === true &&
      data?.properties?.value &&
      data?.properties?.value?.length !== 0 &&
      localStorage.getItem("user.role") !== "admin"
    ) {
      setReadOnly(true);
    } else {
      setReadOnly(false);
    }
  }, [data, isChild]);

  useEffect(() => {
    const labelsToCheck = ["Correspondence address :", "Permanent Address:"];
    const currentLabel = data?.properties?.label;

    if (labelsToCheck.includes(currentLabel)) {
      const currentValue = data?.properties?.value?.trim()?.toLowerCase() || "";
      const comparisonValue = data?.comparison || "";
      if (comparisonValue !== currentValue) {
        setElement((prev) => ({ ...prev, isEdited: true }));
      }else{
        setElement((prev) => ({ ...prev, isEdited: false }));
      }
    }
  }, [data?.properties?.value]);

  const handleChange = (val) => {
    const editableLabels = ["Correspondence address :", "Permanent Address:"];

    const currentLabel = element?.properties?.label;

    if (editableLabels.includes(currentLabel)) {
      const inputValue = val?.trim()?.toLowerCase() || "";
      const comparisonValue = element?.comparison || "";
      console.log({ comparisonValue, inputValue });
      setElement((prev) => ({
        ...prev,
        isEdited: comparisonValue !== inputValue,
      }));
    }
  };

  const foundError = errorInputs?.find(
    (ele) => ele?.label === element?.properties?.label
  );

  return (
    <div className="form-group col-md-12 form-builder-element mb-3">
      <label htmlFor="">
        {element.properties.label}
        <If test={element.properties.required === true}>
          <span style={{ color: "red" }}>*</span>
        </If>
      </label>
      <textarea
        onBlur={onBlurHandler}
        readOnly={readOnly || approve || ocrDisabled}
        onChange={(e) => {
          handleChange(e.target.value);
          if (isInputFieldTouched) {
            isInputFieldTouched();
          }
        }}
        disabled={!element.editable || (defValue && hasChiledReadOnly)}
        className={`form-control form-view ${
          foundError ? "border border-danger" : ""
        }`}
        placeholder={element.properties.placeholder}
        label={element.properties.label}
        data={JSON.stringify(element)}
        defaultValue={defValue && isChild ? defValue : element.properties.value}
      ></textarea>
      {foundError && <p className="text-danger">{foundError?.value}</p>}
    </div>
  );
}

export default TextField;
